// eslint-disable-next-line @typescript-eslint/typedef
export const BasePlaylistRotationControllerEvents = {
  playlistType: {
    multivariantDetected: 'basePlaylistRotator.playlistType.multivariantDetected',
    simpleDetected: 'basePlaylistRotator.playlistType.simpleDetected',
    llDetected: 'basePlaylistRotator.playlistType.llDetected',
    vodDetected: 'basePlaylistRotator.playlistType.vodDetected',
  },
  playlists: {
    playlistRequested: 'basePlaylistRotator.playlists.playlistRequested',
    playlistLoaded: 'basePlaylistRotator.playlists.playlistLoaded',
    playlistLoadingError: 'basePlaylistRotator.playlists.playlistLoadingError',
    playlistParsed: 'basePlaylistRotator.playlists.playlistLoadingError',
    playlistInfo: 'basePlaylistRotator.playlists.playlistInfo',
    vodFragmentsInfo: 'basePlaylistRotator.playlists.VODFragmentsInfo',
    independenceTypeUpdate: 'basePlaylistRotator.playlists.independenceTypeUpdate',
    renditionReportsUpdated: 'basePlaylistRotator.playlists.renditionReportsUpdated',
    lastPlaylistOfSegmentLoaded: 'basePlaylistRotator.playlists.lastPlaylistOfSegmentLoaded',
  },
  fragments: {
    fragmentsDetected: 'basePlaylistRotator.fragments.fragmentsDetected',
    requestReleaseFromCache: 'basePlaylistRotator.fragments.requestReleaseFromCache',
    periodFragmentsFound: 'basePlaylistRotator.fragments.periodFragmentsFound',
  },
};
